// ** Third Party Imports
import { createSlice } from '@reduxjs/toolkit'

// ** Action Imports
import { loginThunk } from './loginThunk'
import { xeroLoginThunk } from './xeroLoginThunk'

interface LoginState {
	isLoading: boolean
	error: string | null
}

const initialState: LoginState = {
	isLoading: false,
	error: null
}

const loginSlice = createSlice({
	name: 'login',
	initialState,
	reducers: {
		reset(state) {
			state.isLoading = false
			state.error = null
		}
	},
	extraReducers: (builder) => {
		builder.addCase(loginThunk.pending, (state) => {
			state.isLoading = true
			state.error = null
		})
		builder.addCase(loginThunk.fulfilled, (state) => {
			state.isLoading = false
		})
		builder.addCase(loginThunk.rejected, (state, action) => {
			state.isLoading = false
			state.error = action.payload ?? 'error'
		})
		builder.addCase(xeroLoginThunk.fulfilled, (state) => {
			state.isLoading = false
		})

		builder.addCase(xeroLoginThunk.rejected, (state, action) => {
			state.isLoading = false
			state.error = action.payload ?? 'Xero login failed'
		})
	}
})

export const loginReducer = loginSlice.reducer

export const { reset } = loginSlice.actions
